import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/models')({
  component: Models,
})

function Models() {
  return (
    <div className="p-2">
      <h3>3D Models</h3>
      <p>This will contain the 3D viewer and model tree hierarchy.</p>
    </div>
  )
} 